<template>
  <div class="wdw-attribute-detail-list" v-if="attributesWithValues.length > 0">
    <div
      v-for="attribute in attributesWithValues"
      v-bind:key="attribute.id"
      :class="attributeClass(attribute)"
      role="listitem"
    >
      <template v-if="compact">
        <strong>{{ attribute.name }}:&nbsp;</strong>
        <a v-if="attribute.type == 'link'" :href="attribute.value" v-dompurify-html="getValue(attribute)"></a>
        <span v-dompurify-html="getValue(attribute)" v-else></span>
      </template>
      <template v-else>
        <strong>{{ attribute.name }}</strong>
        <div>
          <a v-if="attribute.type == 'link'" :href="attribute.value" v-dompurify-html="getValue(attribute)"></a>
          <p v-dompurify-html="getValue(attribute)" v-else></p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { toRefs, computed } from 'vue';

export default {
  name: 'AttributeShowList',
  props: {
    attributes: {
      type: Array,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { attributes } = toRefs(props);
    const attributesWithValues = computed(() => {
      return attributes.value.filter(attr => {
        if (attr.value_all.length > 0) {
          return true;
        }
      });
    });

    function attributeClass(attribute) {
      return {
        ['wdw-attribute-' + attribute.id]: true,
        ['wdw-attribute-' + attribute.code]: true,
        compact: props.compact,
      };
    }

    function getValue(attribute) {
      if (attribute.value === null) {
        return '-';
      }
      return attribute.value_human;
    }

    return {
      attributesWithValues,
      attributeClass,
      getValue,
    };
  },
};
</script>

<style scoped>
/* .thought-attribute {
  display: inline-block;
  margin-right: 7px;
  margin-bottom: 5px;
}
.wdw-attribute-list {
  margin-bottom: 5px;
} */
.wdw-attribute-detail-list .compact {
  padding-bottom: 0.2em;
}
</style>
